import { Stack, type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";

import { useIsMobile } from "../../AppLayout/useResponsive";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { FloatingNavigationItemWrapper } from "./ItemWrapper";

export interface FloatingNavigationOpenMenuButtonProps {
  /**
   * Callback when the button is clicked
   */
  onClick?: () => void;
  /**
   * Additional styles
   */
  sx?: SxProps<Theme>;
}

/**
 * Floating navigation button that appears in the bottom right corner on mobile.
 * Only renders on mobile viewports.
 */
export function FloatingNavigationOpenMenuButton(props: FloatingNavigationOpenMenuButtonProps) {
  const { onClick, sx } = props;
  const isMobile = useIsMobile();

  if (!isMobile) {
    return null;
  }

  return (
    <FloatingNavigationItemWrapper
      sx={mergeSxProps(
        (theme: Theme) => ({
          right: theme.size?.floatingNavigation.margin,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // to be square
          width: theme.size?.floatingNavigation.height,
          borderRadius: theme.borderRadius?.xxxLarge,
        }),
        sx
      )}
      onClick={onClick}
    >
      <Stack sx={{ alignItems: "center", justifyContent: "center", gap: 1 }}>
        <Icon type="ellipsis" size="large" sx={{ color: "inherit" }} />

        <Text semibold variant="caption" sx={{ color: "inherit" }}>
          Menu
        </Text>
      </Stack>
    </FloatingNavigationItemWrapper>
  );
}
